// Coda delle interruzioni (#1339, PDP #1456): consenso → barra del paese → newsletter.
// Regole e motivi in snippets/interruzioni.liquid (qui niente commenti: tetto 3 KB gzip).
(function () {
  'use strict';
  var d = (document.currentScript || {}).dataset || {};
  var FORM = d.form || '', PAGE = d.page || '', FORMS = (d.forms || FORM).split(',');
  var K_VISTE = 'vietti:nl-viste', K_FATTO = 'vietti:nl-fatto', K_MIS = 'vietti:nl-m-', K_PAUSA = 'vietti:nl-pausa', K_ISCR = 'vietti:nl-iscritto';
  var PAUSA_MS = 2592e6, ATTESA_MS = 2000, PRIMA_MS = 2e4, SETTLE_MS = 3000, MARKET_MS = 5000;
  var ESCLUSE = /\/(cart|checkout|account|search|the-company|journal|boutique|pages\/location|contact|shipping|returns|terms-and-conditions|privacy-policy)|\/(apps|blogs|policies)\//;
  var market = 'none', aperti = {}, inCoda = [], fatto = false, attesaMarket = null, timerOpen = null, coda = [];
  var PDP = PAGE === 'product', BARRA = '[data-add-to-cart-proxy]';

  function st(s, fn) { try { return fn(s ? sessionStorage : localStorage); } catch (e) { return null; } }

  function ok() {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; } catch (e) { return false; }
  }
  function ga4(p, n) {
    try {
      var id = Object.keys(window.google_tag_manager || {}).filter(function (k) { return /^G-[A-Z0-9]+$/.test(k); })[0];
      if (id && typeof window.gtag === 'function') return window.gtag('event', 'newsletter_queue', Object.assign({ send_to: id }, p));
    } catch (e) { return; }
    if (n < 20) setTimeout(function () { ga4(p, n + 1); }, 500);
  }
  function invia(p, k) {
    if (k) st(1, function (s) { s.setItem(k, '1'); });
    (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'newsletter_queue' }, p));
    ga4(p, 0);
    try { window.Shopify.analytics.publish('newsletter_queue', p); } catch (e) { /* facoltativo */ }
  }
  function svuota() { while (coda.length) { var x = coda.shift(); invia(x[0], x[1]); } }
  function riprova(n) { if (coda.length && n < 10) setTimeout(function () { ok() ? svuota() : riprova(n + 1); }, 1000); }
  function misura(action, reason, k) {
    var p = { action: action, reason: reason || '', page_type: PAGE, form_id: FORM };
    if (ok()) return invia(p, k);
    if (coda.length < 10 && coda.push([p, k]) === 1) riprova(0);
  }
  function unaVolta(reason) {
    fatto = true;
    if (!st(1, function (s) { return s.getItem(K_MIS + reason); })) misura('skipped', reason, K_MIS + reason);
  }
  document.addEventListener('visitorConsentCollected', function (e) {
    if (e.detail && e.detail.analyticsAllowed) svuota();
  });

  function identificato() {
    var m = /(?:^|;\s*)__kla_id=([^;]+)/.exec(document.cookie || '');
    if (!m) return false;
    try { var o = JSON.parse(atob(decodeURIComponent(m[1]))); return !!(o.$exchange_id || o.$email || o.$phone_number || o.$id); } catch (e) { return false; }
  }
  function banner() {
    var b = document.getElementById('onetrust-banner-sdk');
    if (!b) return false;
    var c = getComputedStyle(b), r = b.getBoundingClientRect();
    return c.display !== 'none' && c.visibility !== 'hidden' && c.opacity !== '0' && r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight;
  }
  function klaviyo() { var k = window._klOnsite; return !!(k && (k._loaded || typeof k.openForm === 'function')); }
  function nessunAperto() { return !Object.keys(aperti).length; }

  function salta(reason) { fatto = true; misura('skipped', reason); }

  function inZona(el) {
    var r = el.getBoundingClientRect(), m = innerWidth < 750;
    return r.width > 0 && r.bottom > (m ? innerHeight * 0.45 : innerHeight - 420) && r.top < innerHeight &&
      (m || r.left < 460 || r.right > innerWidth - 460);
  }
  function ctaLibera() {
    return ![].some.call(document.querySelectorAll('.product__info-container [type="submit"], #notify_button'), inZona);
  }
  function barra() {
    var b = document.querySelector(BARRA), f = aperti[FORM] && document.querySelector('[data-testid="klaviyo-form-' + FORM + '"]');
    if (!b) return;
    var r = f && f.getBoundingClientRect(), q = b.getBoundingClientRect();
    b.style.bottom = r && r.top > innerHeight * 0.3 && r.top < innerHeight && q.left < r.right && q.right > r.left ? innerHeight - r.top + 'px' : '';
  }

  function apri() {
    st(1, function (s) { s.setItem(K_FATTO, '1'); });
    timerOpen = setTimeout(function () { timerOpen = null; misura('skipped', 'not_opened'); }, ATTESA_MS);
    (window._klOnsite = window._klOnsite || []).push(['openForm', FORM]);
  }
  function decidi() {
    if (fatto) return;
    var pausa = +st(0, function (s) { return s.getItem(K_PAUSA); }) || 0;
    if (Date.now() - pausa < PAUSA_MS) return unaVolta('paused');
    if (st(1, function (s) { return s.getItem(K_FATTO); }) !== null) { fatto = true; return; }
    if (banner()) return salta('consent_pending');
    if (market === 'pending' && !attesaMarket) { attesaMarket = setTimeout(function () { salta('market_bar'); }, MARKET_MS); return; }
    if (market !== 'none' || !nessunAperto()) return salta('market_bar');
    if (!FORM || !klaviyo()) return salta('no_klaviyo');
    if (identificato()) return unaVolta('identified');
    fatto = true;
    var k = window.klaviyo;
    if (!k || typeof k.isIdentified !== 'function') return apri();
    var risposto = false, t = setTimeout(function () { if (!risposto) { risposto = true; misura('skipped', 'no_klaviyo'); } }, ATTESA_MS);
    Promise.resolve(k.isIdentified()).then(function (si) {
      if (risposto) return;
      risposto = true; clearTimeout(t);
      if (si) return unaVolta('identified');
      apri();
    }, function () { if (!risposto) { risposto = true; clearTimeout(t); apri(); } });
  }

  window.addEventListener('klaviyoForms', function (e) {
    var x = (e && e.detail) || {}, id = x.formId;
    if (!id) return;
    if (x.type === 'open') {
      aperti[id] = 1;
      if (id !== FORM) return;
      if (PDP) { barra(); setTimeout(barra, 600); addEventListener('scroll', barra, { passive: true }); }
      st(1, function (s) { s.setItem(K_FATTO, '1'); });
      if (timerOpen) { clearTimeout(timerOpen); timerOpen = null; misura('shown'); } else if (!fatto) salta('already_open');
    } else if (x.type === 'close' || x.type === 'submit' || x.type === 'stepSubmit') {
      if (x.type !== 'close' && FORMS.indexOf(id) > -1) st(0, function (s) { s.setItem(K_ISCR, String(Date.now())); });
      if (x.type === 'stepSubmit') return;
      delete aperti[id];
      if (id === FORM) {
        st(0, function (s) { s.setItem(K_PAUSA, String(Date.now())); });
        if (PDP) { removeEventListener('scroll', barra); barra(); }
      }
      if (nessunAperto()) while (inCoda.length) inCoda.shift()();
    }
  });

  window.viettiInterruzioni = {
    market: function (stato) {
      market = stato;
      if (attesaMarket && stato !== 'pending') { clearTimeout(attesaMarket); attesaMarket = null; stato === 'none' ? decidi() : salta('market_bar'); }
    },
    chiedi: function (mostra) { nessunAperto() ? mostra() : inCoda.push(mostra); }
  };

  var viste = (+st(1, function (s) { return s.getItem(K_VISTE); }) || 0) + 1;
  st(1, function (s) { s.setItem(K_VISTE, String(viste)); });
  if (PDP && (d.pdp !== '1' || viste < 2)) return misura('skipped', 'pdp');
  if (PAGE === 'cart' || PAGE === 'policy' || ESCLUSE.test((window.location || {}).pathname || '')) return salta('excluded_page');
  if (d.mkt === '1' || st(0, function (s) { return s.getItem(K_ISCR); })) return unaVolta('subscribed');
  if (identificato()) return unaVolta('identified');
  function dopo(fn) {
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn, { once: true }) : fn();
  }
  if (viste > 1 && !PDP) return dopo(function () { setTimeout(decidi, SETTLE_MS); });
  if (!PDP) misura('skipped', 'first_page');
  var t0 = Date.now(), attesa = false;
  function controlla() {
    var h = document.documentElement.scrollHeight - innerHeight, t = Date.now() - t0 >= PRIMA_MS, s = h > 0 && scrollY / h >= 0.5;
    if (fatto || !(PDP ? t || s : t && s)) return;
    if (PDP && !ctaLibera()) { if (!attesa) misura('skipped', 'pdp_cta'); attesa = true; return; }
    removeEventListener('scroll', controlla);
    decidi();
  }
  addEventListener('scroll', controlla, { passive: true });
  setTimeout(controlla, PRIMA_MS);
})();
